'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import SliderHand from '@components/slider-hand/SliderHand';
import { useViewport } from '@lib/tools/hooks/useViewport';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import SliderLocation from '../slider-location/SliderLocation';
import SliderLocationMob from '../slider-location/SliderLocationMob';
import style from './LocationSliderSection.module.scss';
function LocationSliderSection() {
  const $ = _c(29);
  const [toggle, setToggle] = useState(false);
  const [st6, setSt6] = useState(null);
  const svgRef = useRef(null);
  const {
    isDesktop,
    isMobile,
    isTablet,
    isPortrait,
    isLandscape,
    userAgent,
    viewport
  } = useViewport();
  const isAdaptive = isMobile || isTablet;
  const isAdaptivePortrait = isAdaptive && isPortrait;
  const isAdaptiveLandscape = isAdaptive && isLandscape;
  const hiddenSliderHand = isAdaptivePortrait || isAdaptiveLandscape && userAgent === "none";
  let t0;
  if ($[0] !== st6) {
    t0 = () => () => {
      if (st6) {
        st6.kill();
      }
      setSt6(null);
    };
    $[0] = st6;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isDesktop || $[4] !== st6 || $[5] !== viewport) {
    t2 = () => {
      if (svgRef && viewport) {
        const element = svgRef.current;
        setTimeout(() => {
          setSt6(ScrollTrigger.create({
            trigger: element,
            start: isDesktop ? "top-=100 start" : "top-=350 top",
            ...(isDesktop && {
              scroller: "#smooth-wrapper"
            }),
            scrub: true,
            pin: false,
            onToggle: () => {
              setTimeout(() => {
                setToggle(_temp);
              }, 800);
            }
          }));
          ScrollTrigger.refresh();
          return () => {
            st6.kill();
          };
        }, 1000);
      }
    };
    $[3] = isDesktop;
    $[4] = st6;
    $[5] = viewport;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isDesktop || $[8] !== isMobile || $[9] !== viewport) {
    t3 = [svgRef, isMobile, isDesktop, viewport];
    $[7] = isDesktop;
    $[8] = isMobile;
    $[9] = viewport;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[11] !== isMobile || $[12] !== toggle || $[13] !== viewport) {
    t4 = viewport && <AnimateLines id={!isMobile ? "location-1" : "location-1-mob"} className={style.svgClass} toggle={toggle} />;
    $[11] = isMobile;
    $[12] = toggle;
    $[13] = viewport;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <div data-scroll={true} className={style.svgWrapper} ref={svgRef}>{t4}</div>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={style.title}>Инфраструктура <br /> считанных шагов</div>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = !hiddenSliderHand;
  let t8;
  if ($[18] !== t7) {
    t8 = <SliderHand orientation="right" hidden={t7} />;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isDesktop) {
    t9 = isDesktop && <SliderLocation />;
    $[20] = isDesktop;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== isDesktop) {
    t10 = !isDesktop && <SliderLocationMob />;
    $[22] = isDesktop;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t5 || $[26] !== t8 || $[27] !== t9) {
    t11 = <div data-scroll={true} className={style.container}>{t5}{t6}{t8}{t9}{t10}</div>;
    $[24] = t10;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
}
function _temp() {
  return true;
}
export default LocationSliderSection;